import React from 'react';
import type { FC } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Avatar,
  Button,
  Box,
  colors,
  Container,
  Grid,
  Typography,
  makeStyles,
  Divider
} from '@material-ui/core';
import type { Theme } from 'src/theme';

interface SubsciptionProps {
  className?: string;
  subscriptionRef: any;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    paddingTop: 128,
    paddingBottom: 50
  },
  box: {
    backgroundColor: theme.palette.primary.main,
    display: "flex",
    flexDirection: "column",
    border: 1,
    borderRadius: 7,
    padding: 20,
    paddingBottom: 30,
    // boxShadow: '5px 10px 18px #dbdbdb',
    minHeight: 150,
  },
  middleBox: {
    display: "flex",
    flexDirection: "column", 
    borderColor: theme.palette.primary.main,
    borderStyle: 'solid',
    border: 1,
    borderRadius: 7,
    padding: 20,
    paddingBottom: 30,
    // boxShadow: '5px 10px 18px #dbdbdb',
    minHeight: 150,
  },
}));

const Subsciption: FC<SubsciptionProps> = ({ className, subscriptionRef, ...rest }) => {
  const classes = useStyles();
  
  const individual = `
    <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
      <input type="hidden" name="cmd" value="_s-xclick">
      <input type="hidden" name="hosted_button_id" value="YF23XJ5LED7KE">
      <table>
      <tr><td><input type="hidden" name="on0" value="Subscription Options">Subscription Options</td></tr><tr><td><select name="os0">
      <option value="Monthly Subscription">Monthly Subscription : $70.00 USD - monthly</option>
      <option value="Yearly Subscription">Yearly Subscription : $720.00 USD - yearly</option>
      </select> </td></tr>
      </table>
      <input type="hidden" name="currency_code" value="USD">
      <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_subscribeCC_LG.gif" border="0" name="submit" alt="PayPal - The safer, easier way to pay online!">
      <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
    </form>
  `;

  const individual2 = `
    <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
      <input type="hidden" name="cmd" value="_s-xclick">
      <input type="hidden" name="hosted_button_id" value="X2PKXN5F5WTGL">
      <table>
      <tr><td><input type="hidden" name="on0" value="Subscription Options"></td></tr><tr><td><select name="os0">
      <option value="Monthly">Monthly : $70.00 USD - monthly</option>
      <option value="6 Months ($65/month)">6 Months ($65/month) : $390.00 USD - yearly</option>
      <option value="1 Year ($60/month">1 Year ($60/month : $720.00 USD - yearly</option>
      </select> </td></tr>
      </table>
      <input type="hidden" name="currency_code" value="USD">
      <input type="image" style="margin-top: 10px; margin-left: 50px;" src="https://www.paypalobjects.com/en_US/i/btn/btn_subscribeCC_LG.gif" border="0"
      name="submit" alt="PayPal - The safer, easier way to pay online!">
      <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
    </form>
  `;

  const organization = `
    <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
      <input type="hidden" name="cmd" value="_s-xclick">
      <input type="hidden" name="hosted_button_id" value="DFJT9M6CYCUDW">
      <input type="image"
      src="https://www.paypalobjects.com/en_US/i/btn/btn_subscribeCC_LG.gif" border="0" name="submit" alt="PayPal - The safer, easier way to pay online!">
      <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
    </form>
  `;

  const SubscribeIndividualButton = () => (
    <Box style={{ marginRight: 20 }}>
      <Typography
        variant="h5"
        // align="center"
        color="secondary"
        style={{ fontWeight: 'bold', marginBottom: 5 }}
      >
        Subscription Options:
      </Typography>
      <div dangerouslySetInnerHTML={{ __html: individual }} />
    </Box>
  ); 
  const SubscribeOrganizationButton = () => (
    <Box style={{ marginLeft: 20 }}>
      <Typography
        variant="h3"
        // align="center"
        color="secondary"
        style={{ fontWeight: 'bold'}}
      >
        For Organization:
      </Typography>

      <Typography
        variant="h5"
        // align="center"
        color="secondary"
        style={{ fontWeight: 'bold'}}
      >
        $50/Month
      </Typography>
      <Box style={{ marginTop: 20, marginLeft: 20}}>
        <div dangerouslySetInnerHTML={{ __html: organization }} />
      </Box>
    </Box>
  );

  return (
    <div
      ref={subscriptionRef}
      className={clsx(classes.root, className)}
      {...rest}
    >
      <Container maxWidth="md">
        <Typography
          variant="h1"
          align="center"
          color="secondary"
          style={{ fontWeight: 'bold'}}
        >
          It’s super simple to get started.
        </Typography>
        <Typography
          component="p"
          variant="overline"
          color="textSecondary"
          align="center"
        >
          Begin your journey of ending loans faster, while paying less.
        </Typography>
        <Box mt={8}>
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              xs={12}
              md={4}
            >
              <Box className={classes.box}>
                  <Typography
                    variant="h4"
                    gutterBottom
                    style={{ color: colors.common.white, fontWeight: 'bold' }}
                  >
                    Send Subscription
                  </Typography>
                  <Typography
                    align="left"
                    variant="body1"
                    style={{ color: colors.common.white }}
                  >
                    1. Pay via Paypal Link below
                  </Typography>
                  <Typography
                    align="left"
                    variant="body1"
                    style={{ color: colors.common.white }}
                  >
                    2. Send Proof of Payment to signup@myliberte.app.
                  </Typography>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
            >
                <Box className={classes.middleBox}>
                  <Typography
                    variant="h4"
                    gutterBottom
                    color="primary"
                    style={{ fontWeight: 'bold' }}
                  >
                    Registration Invite
                  </Typography>
                  <Typography
                    align="left"
                    variant="body1"
                    color="primary"
                  >
                    1. Receive Email Invite
                  </Typography>
                  <Typography
                    align="left"
                    variant="body1"
                    color="primary"
                  >
                    2. Follow Registration Link
                  </Typography>
                </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
            >
              <Box className={classes.box}>
                  <Typography
                    variant="h4"
                    gutterBottom
                    style={{ color: colors.common.white, fontWeight: 'bold' }}
                  >
                    Account Setup
                  </Typography>
                  <Typography
                    align="left"
                    variant="body1"
                    style={{ color: colors.common.white }}
                  >
                    1. Register Account
                  </Typography>
                  <Typography
                    align="left"
                    variant="body1"
                    style={{ color: colors.common.white }}
                  >
                    2. Setup Financials
                  </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box style={{ marginTop: 50 }}>
          <Typography
            component="p"
            color="textSecondary"
            align="center"
            style={{ fontFamily: 'Poppins' }}
          >
            Email used to send proof of payment will be the same email to receive the Registration Invite.
          </Typography>
          <Typography
            component="p"
            color="textSecondary"
            align="center"
            style={{ fontFamily: 'Poppins' }}
          >
            Expect to receive the Registration Invite 48-72 hours after receipt of proof of payment.
          </Typography>
          <Typography
            component="p"
            color="textSecondary"
            align="center"
            style={{ fontFamily: 'Poppins' }}
          >
            Automated subscription gateway is currently in development. 
          </Typography>
        </Box>
        <Box style={{ marginTop: 30, display: 'flex', flexDirection: 'row', justifyContent: 'center',  }}>
          <SubscribeIndividualButton />
          {/* <SubscribeOrganizationButton /> */}
        </Box>
        <Divider style={{ marginTop: 50, marginBottom: 50 }}/>
        <Box style={{ marginTop: 20, display: 'flex', justifyContent: 'center', flexDirection: 'row', alignItems: 'center' , alignContent: 'center' }}>
          {/* <Grid
              item
              xs={12}
              md={4}
            >
                
            </Grid> */}
            {/* <Grid
              item
              xs={12}
              md={4}
              style={{ flexDirection: 'row', display: 'flex', backgroundColor: 'red'}}
            > */}
              <Box className={classes.middleBox} style={{ minHeight: 100, position: 'relative', right: -10, width: 180, alignItems: 'center' , alignContent: 'center' }}>
                  <Typography
                    variant="h4"
                    gutterBottom
                    color="primary"
                    style={{ fontWeight: 'bold', textDecoration: 'underline' }}
                  >
                    $70/month
                  </Typography>
                  <Divider style={{ color: 'red' }} />
                  <Typography
                    align="left"
                    variant="body1"
                    color="primary"
                  >
                    Monthly Subscription
                  </Typography>
                </Box>
              <Box className={classes.box} style={{ minHeight: 120, width: 200, display: 'flex', justifyContent: 'center', alignItems: 'center' , alignContent: 'center'}}>
                  <Typography
                    variant="h4"
                    gutterBottom
                    style={{ color: colors.common.white, fontWeight: 'bold', textDecoration: 'underline' }}
                  >
                    $60/month
                  </Typography>
                  <Typography
                    align="left"
                    variant="body1"
                    style={{ color: colors.common.white }}
                  >
                    Yearly Subscription
                  </Typography>
              </Box>
            {/* </Grid> */}
        </Box>
        <Box>
          <Typography
            component="p"
            color="primary"
            align="center"
            style={{ fontFamily: 'Poppins', marginTop: 30 }}
          >
            <b>Zero one-time upfront fee</b> for early access users.
          </Typography>
        </Box>
      </Container>
    </div>
  );
};

Subsciption.propTypes = {
  className: PropTypes.string
};

export default Subsciption;
